import VerifyCode from './VerifyCode';

export default VerifyCode;
